var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "供应商下单", name: "first" } },
            [
              _c("swb-device-require-voucher-voucher", {
                attrs: { voucherIds: _vm.voucherIds }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "拆分下单", name: "second" } },
            [
              _c("swb-device-require-voucher-split-order", {
                ref: "swb_device_require_voucher_split_order",
                attrs: {
                  itemFilter: _vm.itemFilter,
                  voucherIds: _vm.voucherIds,
                  lowCostFlag: _vm.lowCostFlag
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "其他供应商", name: "third" } },
            [
              _c("swb-device-require-voucher-other-vendor", {
                ref: "swb_device_require_voucher_other_vendor",
                attrs: {
                  itemFilter: _vm.itemFilter,
                  lowCostFlag: _vm.lowCostFlag
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06508ec8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06508ec8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/RequireGoodsItemStatis.vue
// module id = 3135
// module chunks = 0